export default "/images/0beb0a5f86a13069a06840ca0a6e64b2.avif";